import { twMerge } from 'tailwind-merge';
import { HTMLProps, PropsWithChildren } from 'react';

type CardProps = PropsWithChildren<{
    elevation?: number;
}> & HTMLProps<HTMLDivElement>;

export const Card = ({ elevation = 1, className, children, ...rest }: CardProps) => {
    if (elevation < 1 || elevation > 5) {
        elevation = 1
    }

    return (
        <div
            {...rest}
            className={twMerge(
                'p-4 rounded-2xl',
                elevation === 1 && 'bg-surface-1',
                elevation === 2 && 'bg-surface-2',
                elevation === 3 && 'bg-surface-3',
                elevation === 4 && 'bg-surface-4',
                elevation === 5 && 'bg-surface-5',
                className
            )}>
            {children}
        </div>
    );
};
